import { pumaAPI, dataAPI } from "./api"

import { Concept, IStatusTransition } from "../models"
import { PumaParsedPaginatedResponse } from "./models/api/puma"
import {
    ODataGetArrayResponse,
    ODataGetResourceResponse,
} from "./models/api/data"

import { StatusTransitionDTO, ConceptDTO } from "./models/dto/concept"

import {
    parseStatusTransitionDto,
    parseConceptDto,
} from "./utils/conceptParsing"
import { IConcept } from "../components/itemdetail"

export const getConcepts = (): Promise<PumaParsedPaginatedResponse<Concept>> =>
    pumaAPI.getJSON("concepts", {})

export const getConcept = (id: number): Promise<IConcept> =>
    dataAPI
        .getJSON<ODataGetResourceResponse<ConceptDTO>>(`Concepts/${id}`, {
            $expand: "DefaultInitialStatus,DefaultFinalStatus,Statuses",
        })
        .then((response) => parseConceptDto(response))

export const getStatusTransitions = (
    id: number,
): Promise<IStatusTransition[]> =>
    dataAPI
        .getJSON<ODataGetArrayResponse<StatusTransitionDTO>>(
            `Concepts/${id}/StatusTransitions`,
            {
                $expand: "fromStatus,toStatus",
                $filter: "isActive eq true",
            },
        )
        .then((response) => response.value.map(parseStatusTransitionDto))
